import { useModuleBEM } from "@b2bportal/core-themes";
import type { Lodging } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  Location,
  Rating,
  HomeUserRating,
  HomeVacationRentalTag,
} from "@tenant/hotels";
import clsx from "clsx";
import { normalizeReviewScore } from "../HomeCustomerReviews/helpers";
import styles from "./HomeCardPretitle.module.scss";

export const HomeCardPretitle = ({
  hotel,
  className,
}: {
  hotel: Lodging;
  className?: string;
}) => {
  const [block, cn] = useModuleBEM(styles, "HomeCardPretitle");

  const { t } = useI18nContext();

  const score = normalizeReviewScore(
    hotel.homesListingDetails.listingContent.homesUserRating.score
  );

  return (
    <div className={clsx(block, className)}>
      <Rating className={cn("rating")} hotel={hotel} />
      <Location className={cn("location")} city={hotel.lodging.city} />
      <span className={cn("entire-home")}>
        {t("core-hotels.homes.entireHome")}
      </span>
      <HomeUserRating className={cn("user-rating")} score={score} size="sm" />
      <HomeVacationRentalTag className={cn("vacation-rental-tag")} />
    </div>
  );
};
